:host {
	--uui-simpletable-padding: 1rem 0rem;
}

.uui-simple-table-wrapper table {
	font-family: var(--uui-primary-font-family);
  	max-width:100%;
	background-color:transparent;
	border-collapse:collapse;
	border-spacing:0;
  	width:100%;
}

.uui-simple-table-wrapper table td,
.uui-simple-table-wrapper table th {
  	padding: var(--uui-simpletable-padding);
	text-align:left;
	vertical-align:middle;
  	border-bottom:1px solid var(--uui-theme-variant-300);
	/* width:0%; */
	word-break: break-word;
}

.uui-simple-table-wrapper.zebra-striping tbody tr:nth-child(odd) {
	background-color: var(--uui-gray-07);
 }
